import React from 'react';
import { FormControl, FormHelperText } from '@mui/material';
import { useController, UseControllerProps } from 'react-hook-form';
import { Quill } from '../Quill/Quill';
import ReactQuill from 'react-quill';
import { formats, modules } from '../Quill/Editor';


interface IProps extends UseControllerProps {
  intialContent?: string;
  disabled?: boolean;
  placeholder?: string;
  onChange?: (description: string | undefined | null) => void;
  modules?: String;
  formats?: string[];
  maxLength?: number;
}

export const AppQuill = (props: IProps) => {
  const { fieldState, field } = useController({ ...props, defaultValue: props.defaultValue != null ? props.defaultValue : ''  });

  const handleChange = (newValue: string) => {
    const value = newValue !== '<p><br></p>' ? newValue : null;
    field.onChange(value);
    if (props.onChange) {
      props.onChange(value);
    }
  }

  return (
    <FormControl fullWidth error={!!fieldState.error}>
      <ReactQuill
        {...props}
        {...field}
        readOnly={props.disabled}
        theme='snow'
        onChange={handleChange}
        value={field.value}
        modules={props.modules ?? modules}
        formats={props.formats ?? formats}
        bounds={'.app'}
        placeholder={props.placeholder ?? "Write something..."}
      />
      <FormHelperText>{fieldState.error?.message}</FormHelperText>
    </FormControl>
  )
}